/**
 * @description Video Property as per MPX metadata.videoProperty array field
 */
export enum MPXVideoProperty {
	AA_ORIGINAL = 'AA Original',
	BBLF = 'BBLF',
	BRANDED = 'Branded',
	CLIP = 'Clip',
	DAI_LIVE_STREAM = 'DAI Live Stream',
	DVR = 'DVR',
	EPISODELESS = 'Episodeless',
	FRANCHISE_STANDALONE = 'Franchise Standalone',
	FULL_EPISODE = 'Full Episode',
	HLS_AES_LIVE_STREAM = 'HLS AES Live Stream',
	KIDS = 'Kids',
	LEGACY_BITRATE_LIMIT = 'Legacy Bitrate Limit',
	LINEAR_AD_TRACKING_PLUGIN = 'Linear Ad Tracking Plugin',
	NO_AIR = 'No-Air',
	OPEN_ENDED = 'Open-Ended',
	PREMIUM = 'Premium',
	PROMO_FULL_EPISODE = 'Promo Full Episode',
	SEASONLESS = 'Seasonless',
	SEGMENT = 'Segment',
	SERIES_STANDALONE = 'Series Standalone',
	START_OVER = 'Startover',
}